/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Proof_OverlineInputs */

const en_dr_proof_overline = /** @type {(inputs: Dr_Proof_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proof-of-Why`)
};

const id_dr_proof_overline = /** @type {(inputs: Dr_Proof_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proof-of-Why`)
};

/**
* | output |
* | --- |
* | "Proof-of-Why" |
*
* @param {Dr_Proof_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_proof_overline = /** @type {((inputs?: Dr_Proof_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Proof_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_proof_overline(inputs)
	return en_dr_proof_overline(inputs)
});